import PropTypes from 'prop-types';

import CityInstitutionsList from './CityInstitutionsList';

function orderCitiesAlphabetically(cities) {
  return cities.sort((a, b) => {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  });
}

const EMPTY_OBJECT = {};

const InstitutionCities = ({ institutionsByCity = EMPTY_OBJECT }) => {
  const cities = Object.keys(institutionsByCity);
  const institutionsOrderedByCity = orderCitiesAlphabetically(cities);

  return (
    <div>
      {institutionsOrderedByCity.map(city => (
        <CityInstitutionsList
          key={city}
          city={city}
          institutions={institutionsByCity[city]}
        />
      ))}
    </div>
  );
};

InstitutionCities.propTypes = {
  institutionsByCity: PropTypes.object
};

export default InstitutionCities;
